import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'
import moment from 'moment'

const DatePicker = ({ displayName, placeholder, description, errorMessage, disabled, value, onChange }) => {
  return (
    <FieldWrapper
      displayName={displayName}
      description={description} 
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="date-picker-field-container">
        <input
          type="date"
          placeholder={displayName || placeholder}
          value={value ? moment(value).format('YYYY-MM-DD') : ''}
          onChange={onChange ? (e) => onChange(e.target.value) : () => {}}
          disabled={disabled}
        />
      </div>
    </FieldWrapper>
  )
}

DatePicker.propTypes = {
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default DatePicker
